export default __webpack_public_path__ + "static/media/approved.2b69479a.svg";